(ns minorodata.sql-console.subs
  (:require [clojure.string]
            [applied-science.js-interop :as js-interop]
            [re-posh.core :as re-posh]
            [re-frame.core :as re-frame]
            ["humanize-duration" :as humanizeDuration]))


(re-frame/reg-sub
  :sql-console.meta/tree-view-data
  (fn [_ [_ _]]
    (let [nodes @(re-posh/subscribe [:sql-metadata/prop :sql-metadata/tree])]
      (when nodes
        (js-interop/call js/Object :values nodes)))))


(re-frame/reg-sub
  :sql-console.meta/tree-view
  (fn [[_ node]]
    (re-frame/subscribe [:sql-console.meta/tree-view-data node]))
  (fn [node-data]
    (vec node-data)))


(re-frame/reg-sub
 :sql-console.data/tabbed-data
 (fn [db]
   (let [current-tab-idx  @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])
         tdc              @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         tab-data         (nth tdc current-tab-idx {})
         current-metadata (:metadata tab-data)
         tab-id           (get-in current-metadata [:tab-id] (str current-tab-idx))
         data             @(re-posh/subscribe [:sql-console.data/data-for-tab tab-id])]
     (if (empty? data)
       [{}]
       (for [specimen data]
         (if (contains? #{:update-count} (-> specimen ffirst first))
           (let [row (-> data ffirst str)]
             {:data            [{"RESULT" row}]
              :indexed-data    [{"0-RESULT" row}]
              :headers         [{:title "RESULT" :field "RESULT"}]
              :indexed-headers [{:title "RESULT" :field "0-RESULT"}]})

           (let [headers            (first specimen)
                 indexed-headers    (map-indexed (fn [idx h] [idx h]) headers)
                 rows               (rest specimen)
                 indexed-header-id  (fn [[idx c]] (str idx "-" c))
                 indexed-col-fn     (fn [[idx c]] {:title c :field (indexed-header-id [idx c])})
                 col-fn             (fn [c] {:title c :field c})
                 indexed-header-ids (map indexed-header-id indexed-headers)]
             (when (some? headers)
               {:data            (mapv (fn [cols] (apply assoc {} (interleave headers cols)))
                                       rows)
                :headers         (map col-fn headers)
                :indexed-data    (mapv (fn [cols] (apply assoc {} (interleave indexed-header-ids cols)))
                                       rows)
                :indexed-headers (map indexed-col-fn indexed-headers)}))))))))


(re-frame/reg-sub
  :sql-console.subs/ordered-sql-query-history
  (fn []
    (re-frame/subscribe [:sql-query-history/pull '[{:sql-query-history/queries [:sql-query/sql-query-id :sql-query/order :sql-query/created-at]}]]))
  (fn [history]
    (let [{:sql-query-history/keys [queries]} history]
      (reverse (sort-by :sql-query/created-at queries)))))


(re-frame/reg-sub
  :sql-console.subs/ordered-sql-query-favourites
  (fn []
    (re-frame/subscribe [:sql-query-favourites/pull '[{:sql-query-favourites/queries [:sql-query/sql-query-id :sql-query/order :sql-query/created-at]}]]))
  (fn [history]
    (let [{:sql-query-favourites/keys [queries]} history]
      (reverse (sort-by :sql-query/created-at queries)))))


(re-frame/reg-sub
  :sql-console.data/query-time
  (fn []
    [(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])
     (re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])])
  (fn [[current-tab-idx tdc]]
    (let [tab-data (nth tdc current-tab-idx {})
          time-ms  (:query-duration tab-data)]
      (when (pos? time-ms)
        (humanizeDuration time-ms {:units ["m" "s" "ms"]})))))


(re-frame/reg-sub
  :sql-console.misc/tabs-local-storage-key
  (fn []
    (re-posh/subscribe [:user/prop :user/uid]))
  (fn [uuid]
    (str "sql-console-tabs-" uuid)))


(re-frame/reg-sub
 :sql-console.misc/tab-metadata-local-storage-key
 (fn []
   (re-posh/subscribe [:user/prop :user/uid]))
 (fn [uuid]
   (str "sql-console-tabs-metadata-" uuid)))


(re-frame/reg-sub
  :sql-console.misc/config-local-storage-key
  (fn []
    (re-posh/subscribe [:user/prop :user/uid]))
  (fn [uuid]
    (str "sql-console-config-" uuid)))


(re-frame/reg-sub
 :sql-console.misc/load-initial-tabs
 (fn []
   (re-posh/subscribe [:sql-console.misc/tabs-local-storage-key]))
 (fn [tabs-key]
   @(re-posh/subscribe [:app.subs/get-local-storage tabs-key [""]])))


(re-frame/reg-sub
 :sql-console.misc/load-initial-metadata
 (fn []
   (re-posh/subscribe [:sql-console.misc/tab-metadata-local-storage-key]))
 (fn [metadata-key]
   (mapv #(js->clj % :keywordize-keys true) @(re-posh/subscribe [:app.subs/get-local-storage metadata-key [{}]]))))


(re-frame/reg-sub
 :sql-console.misc/load-initial-config
 (fn []
   (re-posh/subscribe [:sql-console.misc/config-local-storage-key]))
 (fn [config-key]
   @(re-posh/subscribe [:app.subs/get-local-storage config-key {}])))


(re-frame/reg-sub
 :sql-console.data/data-for-tab
 (fn [db [_ tab-id]]
   (get-in db [:sql-console/data tab-id] [])))

(re-frame/reg-sub
 :ai-chat/messages
 (fn [db _]
   (get db :ai-chat-messages)))
